/* Copyright (c) 2022 Xperi. All Rights Reserved.  */

import { DeviceModel } from './device/DeviceModel';

export class CommonHeaders {
    public headers = {
        ApplicationName: DeviceModel.getTiVoSettings().getAppName(),
        ApplicationFeatureArea: 'all',
        ApplicationVersion: DeviceModel.getAppVersionName(),
        DeviceType: DeviceModel.getTiVoSettings().getDeviceType(),
        ProductName: DeviceModel.getTiVoSettings().getAppName(),
        'Accept-Language': DeviceModel.getTVProperties().getDateLocale(),
        'Cache-Control': 'no-cache',
        'Content-Type': 'application/json',
    };

    constructor(applicationFeatureArea: string) {
        this.headers.ApplicationFeatureArea = applicationFeatureArea;
    }
}
